function getLocalTime(i) {
  if (typeof i !== 'number') return;
  var d = new Date();
  var len = d.getTime();
  var offset = d.getTimezoneOffset() * 60000;
  var utcTime = len + offset;
  return new Date(utcTime + 3600000 * i);
}

window.getNextDate = function (date, day) {
  var dd = new Date(date);
  console.log(dd);
  dd.setDate(dd.getDate() + day);
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1;
  var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
  return y + '/' + m + '/' + d;
};
var $ = jQuery;
// 时区 根据时区更改不同地区的时间
var timeZoneParams = -6;
$(function () {
  $('.product-pic li').each(function () {
    if ($(this).data('id') == '1533987258441') {
      $(this).find('.price span').find('.money').text('$109.00');
    }
    if ($(this).data('id') == '7743593316594') {
      $(this).find('.price span').find('.money').text('$99.00');
    }
  });

  if ($('.ht').length) {
    var date = getLocalTime(timeZoneParams);
    var date_day = date.getDate();
    var date_month = date.getMonth() + 1;
    var date_year = date.getFullYear();
    var endTime = getNextDate(date_year + '/' + date_month + '/' + date_day, 1);
    var endAllTime = new Date(endTime).getTime() - date;

    function timerMember(intDiff) {
      var hour = 0,
        minute = 0,
        second = 0;
      intDiff = intDiff - 0;
      if (intDiff > 0) {
        hour = Math.floor(intDiff / 1000 / 60 / 60);
        minute = Math.floor((intDiff / 1000 / 60) % 60);
        second = Math.floor((intDiff / 1000) % 60);
      }
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (minute < 10) {
        minute = '0' + minute;
      }
      if (second < 10) {
        second = '0' + second;
      }
      $('.newhour').html(hour);
      $('.newmin').html(minute);
      $('.newmiao').html(second);
    }
    var groupTime = setInterval(function () {
      if (endAllTime > 0) {
        timerMember(endAllTime);
        endAllTime -= 1000;
      } else {
        date = getLocalTime(timeZoneParams);
        date_day = date.getDate();
        date_month = date.getMonth();
        date_year = date.getFullYear();
        endTime = getNextDate(date_year + '/' + date_month + '/' + date_day);
        endAllTime = new Date(endTime).getTime() - date;
      }
    }, 1000);
  }
});
setTimeout(function () {
  $('.goods-one').click(function () {
    $('#wigs_tab2').addClass('none');
    $('#wigs_tab1').removeClass('none');
  });
}, 1000);
setTimeout(function () {
  $('.goods-two').click(function () {
    $('#wigs_tab1').addClass('none');
    $('#wigs_tab2').removeClass('none');
  });
}, 1000);
setTimeout(function () {
  $('.wigs .left').click(function () {
    $('.wigs .left').addClass('color1');
    $('.wigs .right').removeClass('color1');
  });
}, 1000);
setTimeout(function () {
  $('.wigs .right').click(function () {
    $('.wigs .left').removeClass('color1');
    $('.wigs .right').addClass('color1');
  });
}, 1000);
